import { Card, Typography,makeStyles } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { faBell, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Pagination from '@material-ui/lab/Pagination';
import AgGrid from 'components/agGrid/AgGrid';
import AlarmRenderer from 'components/agGrid/AlarmRenderer';
import BooleanRenderer from 'components/agGrid/BooleanRenderer';
import { dateComparator } from 'components/agGrid/DateComparator';
import FamilleRenderer from 'components/agGrid/FamilleRenderer';
import TopBar from 'components/layout/TopBar';
import { callAxios } from 'components/utils/FormatData';
import { genKey, setStorage } from 'components/utils/Storage';
import { REMOVE_MESSAGE } from 'constants/constants';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { SvgIcon } from '../../components/utils/SvgIcon';
import { URL_API } from '../../constants/settings';
import useWindowSize from './../../hooks/useWindowSize';
import EquipmentsActions from './EquipmentsActions';
import EquipmentTopBar from './EquipmentTopBar';
import { distanceEnKm } from '../../components/utils/Position.js';



const useStyles = makeStyles({
  list: {
    padding: '5px',
  },
  card: {
    margin: '10px',
    overflow: 'visible',
    borderRadius: '5px',
    boxShadow: '0px 0px 5px 0px rgb(0 0 0 / 20%)',
    display: 'flex',
    flexDirection: 'row',
    flex: '0 0',
    justifyContent: 'left'
  },
  icon: {
    flex: '0 0 4rem',
    display: 'flex'
  },
  dateDerniereAlarme: {
    flex: '0 0 9rem',
    display: 'flex',
    flexDirection: 'column'
  },
  detail: {
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column'
  },
  distance: {
    flex: '0 0 5rem',
    display: 'flex',
    flexDirection: 'column'
  }
});

const Equipments = (props) => {
  const alert = useAlert();
  const classes = useStyles();
  const history = useHistory();
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [equipments, setEquipments] = useState([]);
  const [filterEquipments, setFilterEquipments] = useState([]);
  const [equipmentFamily, setEquipmentFamily] = useState([]);
  const [equipmentAutoroute, setEquipmentAutoroute] = useState([]);
  const [componentHeight, setComponentHeight] = useState(height - 160);
  const [columnDefs] = useState([
    { headerName: 'id', field: 'id', hide: true, },
    { headerName: 'id société', field: 'idSociete', suppressMovable: true, resizable: true, sortable: true, flex: 1, minWidth: 150 },
    { headerName: 'famille', field: 'famille', cellRenderer: 'familleRenderer', suppressMovable: true, resizable: true, sortable: true, maxWidth: 100 },
    { headerName: 'al.', field: 'alarme', cellRenderer: 'alarmRenderer', suppressMovable: true, resizable: true, sortable: true, maxWidth: 75 },
    { headerName: 'der. al.', field: 'alarmLastDateDeb', valueFormatter: params => params.data.alarmLastDateDeb ? moment(params.data.alarmLastDateDeb).format('DD/MM/YYYY à HH:mm:ss') : '', suppressMovable: true, resizable: true, sortable: true, comparator: dateComparator, sort: 'asc', hide: false, maxWidth: 175 },
    { headerName: '# al.', field: 'alarmNbActiv', suppressMovable: true, resizable: true, sortable: true, maxWidth: 75 },
    { headerName: 'toponyme', field: 'toponyme', suppressMovable: true, resizable: true, sortable: true, filter: true, cellStyle: { justifyContent: 'left' }, flex: 2, minWidth: 300 },
    { headerName: 'axe', field: 'autoroute', suppressMovable: true, resizable: true, sortable: true, filter: true, maxWidth: 75 },
    { headerName: 'sens', field: 'sens', suppressMovable: true, resizable: true, sortable: true, maxWidth: 75 },
    { headerName: 'pr', field: 'pr', valueFormatter: params => params.data.pr ? params.data.pr : '', suppressMovable: true, resizable: true, sortable: true, maxWidth: 100,
      comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
        if (nodeA.data.pk && nodeB.data.pk) {
          if (nodeA.data.pk < nodeB.data.pk) {
            return -1;
          } else {
            return 1;
          }
        }
        return -1;
      }
    },
    { headerName: 'description gmao', field: 'gmaoDescription', suppressMovable: true, resizable: true, sortable: true, filter: true, cellStyle: { justifyContent: 'left' }, flex: 3, minWidth: 300 },
  ]);
  const [contratGridOptions, setContratGridOptions] = useState({
    suppressCellSelection: true,
    suppressHorizontalScroll: false,
    animateRows: true,
    rowClassRules: {
      'alarm-equipment-red': function (params) {
        return params.data.alarmNbActiv > 0 && !params.data.alarmesAcquittees;
      },
    },
  });
  const frameworkComponents = {
    booleanRenderer: BooleanRenderer,
    familleRenderer: FamilleRenderer,
    alarmRenderer: AlarmRenderer
  };
  const [actualPage, setActualPage] = useState(1);
  const storeFilter = useSelector(state => state.filter);
  const storeWs = useSelector(state => state.websocket);
  const userPosition = useSelector(state => state.userPosition);
  const dispatch = useDispatch();
  var notif = new Audio('/notif.mp3');

  // Chargement du composant
  useEffect(() => {
    document.title = 'SED - Équipements';
  }, []);

  // Changement de position de l'utilisateur ou de la liste des équipements
  useEffect(() => {
    if (equipments && isMobile) {
      console.log('[GEO] Détection d\'un changement de position ou de la liste des équipements');
      console.log('[GEO] Recalcul des distances');
      console.log(`[GEO] Position utilisateur = {Latitude: ${userPosition?.latitude}, Longitude: ${userPosition?.longitude}}`);
      let equipementsUpdated = [];
      equipments.forEach(
        (element) =>  {
          element.distance = distanceEnKm(element, userPosition);
          equipementsUpdated.push(element);
        }
      )
      const listEquipements = sorterEquipment(equipementsUpdated);
      setFilterEquipments(listEquipements);
      if (storeFilter.search && storeFilter.search !== "") {
        filterCards(storeFilter.search, listEquipements);
      }
    }
  }, [userPosition, equipments]);

  // Push Websocket - Refresh du composant
  useEffect(() => {
    if (storeWs.count && storeWs.count > 0) {
      let equipementsUpdated = [...equipments];
      for (const aMsgWs of storeWs.messages) {
        // Boucle sur l'ensemble des messages du websocket
        const type = aMsgWs['Type'];
        if (type.startsWith("sed.EQUIPEMENT")) {
          const equipment = aMsgWs['Payload'];
          let action = "NOTHING";
          let initialEquipment = null;
          // Modification de la liste des équipements
          if (equipment) {
            const equipmentMatchesActualFilters = checkIfEquipmentMatchesActualFilters(equipment);
            const equipmentNotify = equipment['notif'] === 1 && equipmentMatchesActualFilters;
            const equipmentIndex = equipementsUpdated.findIndex((e) => e.id === equipment['id']);

            // Notification sonore pour les nouvelles alarmes
            if (document.getElementById("switch-sound-notif").checked && equipmentNotify) {
              notif.play();
            }
            // Gestion de refresh du composant
            switch (type) {
              case "sed.EQUIPEMENT.create":
              case "sed.EQUIPEMENT.update":
                if (userPosition?.latitude && userPosition?.longitude) {
                  equipment.distance = distanceEnKm(equipment, userPosition);
                } else {
                  equipment.distance = -1;
                }
                if (equipmentMatchesActualFilters) {
                  if (equipmentIndex > -1) {
                    action = "UPDATE";
                    initialEquipment = { ...equipementsUpdated[equipmentIndex] };
                    equipementsUpdated[equipmentIndex] = equipment;
                  } else {
                    action = "ADD";
                    equipementsUpdated.push(equipment);
                  }
                } else {
                  if (equipmentIndex > -1) {
                    action = "REMOVE";
                    initialEquipment = { ...equipementsUpdated[equipmentIndex] };
                    equipementsUpdated.splice(equipmentIndex, 1);
                  }
                }
                break;
              case "sed.EQUIPEMENT.delete":
                if (equipmentIndex > -1) {
                  action = "REMOVE";
                  initialEquipment = { ...equipementsUpdated[equipmentIndex] };
                  equipementsUpdated.splice(equipmentIndex, 1);
                }
                break;
            }

            // TODO: Log à décommenter pour vérifier le bon fonctionnement du refresh
            console.log(`EQUIPEMENT > ${action} > ${equipment.idSociete} > `, initialEquipment, equipment );

            // Suppression du message du store
            dispatch({ type: REMOVE_MESSAGE, payload: equipment.id });
            setEquipments(equipementsUpdated);
          }
        }
      }
    }
  }, [storeWs]);

  // Gestion de resize de la fenêtre
  useEffect(() => {
    setComponentHeight(height - 90 - document.getElementById('component-topbar').clientHeight);
  }, [width, height]);

  // Gestion des filtres
  useEffect(() => {
    callApis();
    if (document.getElementById('component-topbar')) {
      setComponentHeight(height - 90 - document.getElementById('component-topbar').clientHeight);
    }
  }, [storeFilter.alarmType, storeFilter.familyEquipment, storeFilter.autorouteEquipment]);

  // Gestion de la recherche en mode mobile
  useEffect(() => {
    if (isMobile) {
      if (storeFilter.search && storeFilter.search !== "") {
        filterCards(storeFilter.search);
      } else {
        callApis();
      }
    }
  }, [storeFilter.search]);

  // Refresh component websocket
  useEffect(() => {
    if (props.wsStatus !== null) {
      callApis();
    }
  }, [props.wsStatus]);

  // Appel APIs
  const callApis = () => {
    let paramsFilter = new URLSearchParams();
    // Ajout des paramétres concernant le type d'alarme
    switch (storeFilter.alarmType) {
      case 1:
        paramsFilter.append("avecAlarmeActive", "true");
        break;
      case 2:
        paramsFilter.append("avecAlarmeActive", "true");
        paramsFilter.append("alarmeAllAcquit", "false");
        break;
      case 3:
        paramsFilter.append("avecAlarmeActive", "true");
        paramsFilter.append("alarmeAllAcquit", "true");
        break;
      case 4:
        paramsFilter.append("horsExploitation", "true");
        break;
    }
    // Ajout du paramétre sur les types de famille
    if (storeFilter.familyEquipment && storeFilter.familyEquipment.length > 0) {
      storeFilter.familyEquipment.forEach((f) => {
        paramsFilter.append("familles", f);
      });
    }
    // Ajout du paramétre sur les autoroutes
    if (storeFilter.autorouteEquipment && storeFilter.autorouteEquipment.length > 0) {
      storeFilter.autorouteEquipment.forEach((f) => {
        paramsFilter.append("autoroutes", f);
      });
    }
    // Récupération de la liste des familles d'équipement
    callAxios(props.wsStatus, "param_list_familles", { method: 'get', url: URL_API + '/familles' }, null, alert)
      .then((res) => {
        setEquipmentFamily(['Toutes'].concat(res));
        setStorage(genKey("param_list_familles"), res);
      });
    // Récupération de la liste des autoroutes
    callAxios(props.wsStatus, "param_list_autoroutes", { method: 'get', url: URL_API + '/autoroutes' }, null, alert)
      .then((res) => {
        setEquipmentAutoroute(['Toutes'].concat(res));
        setStorage(genKey("param_list_autoroutes"), res);
      });

    // Récupération des équipements
    fetchEquipments(paramsFilter);
  };

  // Récupération des équipements
  const fetchEquipments = (params) => {
    callAxios(props.wsStatus, "equipments", { method: 'get', url: URL_API + '/equipements', params: params }, setLoading, alert)
      .then((res) => {
        const listEquipements = sorterEquipment(res);
        setEquipments(listEquipements);
        setStorage(genKey("equipments"), listEquipements);
      });
  };

  /**
   * Trier la liste des équipements
   *  Sur desktop, tri par nombre d'alarme active
   *  Sur mobile, tri par distance depuis la position de l'utilisateur
   * @param data
   * @returns {*}
   */
  const sorterEquipment = (data) => {
    if (data) {
      if (isMobile) {
        return data.sort((a, b) => ((a.distance<0)?1:((b.distance<0)?-1:((a.distance<b.distance)?-1:1))));
      } else {
        return data.sort((a, b) => (a.alarmNbActiv > b.alarmNbActiv ? -1 : 1));
      }
    } else {
      return data;
    }
  };

  // Génération du template de la liste d'équipement
  const generateCardTheme = (equipement) => {
    let style = null;
    switch (equipement.etat) {
      case 0:
        style = { borderLeft: '5px solid #000000' };
        break;
      case 1:
      case 2:
        style = { borderLeft: '5px solid #a5c946' };
        break;
      case 3:
        style = { borderLeft: '5px solid #f18d2d' };
        break;
      case 4:
        style = { borderLeft: '5px solid #f14a2d' };
        break;
      case 5:
        style = { borderLeft: '5px solid #8da1a7' };
        break;
    }
    return style;
  };

  // Génération de la couleur de la famille d'équipement
  const generateLogoColor = (equipement) => {
    switch (equipement.etat) {
      case 0:
        return "#000";
      case 1:
      case 2:
        return "#a5c946";
      case 3:
        return "#f18d2d";
      case 4:
        return "#f14a2d";
      case 5:
        return "#8da1a7";
    }
  };

  // Gestion du double clic ag-grid
  const handleOnDoubleClick = (e) => {
    history.push("/equipement/" + e.data.id)
  };

  // Gestion du double clic ag-grid
  const handleOnClickOnList = (data) => {
    history.push("/equipement/" + data.id)
  };

  const handleChangePage = (event, value) => {
    setActualPage(value);
  }

  // Filtrage des cards en mode mobile
  const filterCards = (searchValue, values) => {
    const filteredList = [];
    if (values) {
      values.map(
        value => {
          if (Object.values(value).toString().toLowerCase().includes(String(searchValue).toLowerCase())) filteredList.push(value);
        }
      )
    } else {
      equipments.map(
        value => {
          if (Object.values(value).toString().toLowerCase().includes(String(searchValue).toLowerCase())) filteredList.push(value);
        }
      )
    }
    setFilterEquipments(filteredList);
  };

  // Contrôle de l'équipement pour savoir si on l'ajout aux équipements en cours
  const checkIfEquipmentMatchesActualFilters = (equipmentWillCheck) => {
    let displayInTab = true;
    // Contrôle du type d'alarmes
    switch (storeFilter.alarmType) {
      case 1:
        if (equipmentWillCheck.alarmNbActiv < 1) displayInTab = false;
        break;
      case 2:
        if (equipmentWillCheck.alarmNbActiv < 1 || (equipmentWillCheck.alarmNbActiv >= 1 && equipmentWillCheck.alarmesAcquittees)) displayInTab = false;
        break;
      case 3:
        if (equipmentWillCheck.alarmNbActiv < 1 || (equipmentWillCheck.alarmNbActiv >= 1 && !equipmentWillCheck.alarmesAcquittees)) displayInTab = false;
        break;
      case 4:
        if (equipmentWillCheck.etat < 5) displayInTab = false;
        break;
    }
    // Si une ou plusieurs familles sont sélectionnées dans le filtre, vérifie si la famille de l'équipement appartient à une des familles sélectionnées
    if (storeFilter.familyEquipment && storeFilter.familyEquipment.length > 0 && !storeFilter.familyEquipment.includes(equipmentWillCheck.famille)) {
      displayInTab = false;
    }
    // Si une ou plusieurs autoroutes sont sélectionnées dans le filtre, vérifie si l'autoroute de l'équipement appartient à une des autoroutes sélectionnées
    if (storeFilter.autorouteEquipment && storeFilter.autorouteEquipment.length > 0 && !storeFilter.autorouteEquipment.includes(equipmentWillCheck.autoroute)) {
      displayInTab = false;
    }
    // Si une chaîne de caractères est indiquée dans le filtre, vérifie que l'on retrouve la chaîne dans le détail de l'équipement
    if (storeFilter.search && storeFilter.search !== "" && !JSON.stringify(equipmentWillCheck).toLowerCase().includes(String(storeFilter.search).toLowerCase())) {
      displayInTab = false;
    }
    return displayInTab;
  };

  if (isMobile) {
    return (
      <div id="equipments" className={'panel-contenu-mobile-tablette'} style={{ height: height - 60 }}>
        <EquipmentTopBar className="topbar-contenu" color={props.params.color} buttons={
          <EquipmentsActions
            equipmentFamily={equipmentFamily}
            equipmentAutoroute={equipmentAutoroute}
            wsStatus={props.wsStatus} />
        }
        />
        <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>
          <ClipLoader
            color="#0094ca"
            loading={loading}
            css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
            size={50}
          />
          {!loading &&
            <div className={classes.list}>
              {
                filterEquipments && filterEquipments.map((e, i) => {
                  if ((i >= 50 * (actualPage - 1)) && (i < 50 * actualPage)) {
                    const equipmentDescription = e.gmaoDescription?e.gmaoDescription:e.idSociete;
                    const equipmentDistance = (e.distance && e.distance>=0)?(e.distance.toFixed(2)+' km'):'';
                    return (
                      <Card key={e.id} className={classes.card} style={generateCardTheme(e)} onClick={() => handleOnClickOnList(e)}>
                        <div className={classes.icon}>
                          <SvgIcon color={generateLogoColor(e)} size="100%" type={e.famille}/>
                        </div>
                        <div className={classes.detail}>
                          <Typography style={{ color: generateLogoColor(e) }}>
                          {equipmentDescription}
                          </Typography>
                          {e.alarmLastDateDeb &&
                          <Typography style={{textAlign : 'right'}}>
                            Dernière alarme : <b>{moment(e.alarmLastDateDeb).format('DD/MM/YYYY à HH:mm')}</b>
                          </Typography>
                          }
                        </div>
                        <div className={classes.distance}>
                          <div style={{textAlign : 'right'}}>
                          <Typography variant='body2'>{equipmentDistance}</Typography>
                          </div>
                          {e.alarmNbActiv > 0 &&
                          <div style={{ textAlign: 'center' }}>
                            <Badge badgeContent={e.alarmNbActiv} color="secondary" style={{ margin: '10px' }}>
                              <FontAwesomeIcon icon={faBell} size={'lg'} />
                            </Badge>
                          </div>
                          }
                        </div>
                      </Card>
                    );
                  }
                  return null;
                })
              }
              {
                ((filterEquipments && filterEquipments.length === 0) || !filterEquipments) &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <h4>Aucun équipement à afficher</h4>
                </div>
              }
              {
                filterEquipments && filterEquipments.length > 50 &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Pagination count={Math.ceil(filterEquipments.length / 50)} page={actualPage} onChange={handleChangePage} shape="rounded" />
                </div>
              }
            </div>
          }
        </div>
      </div>
    );
  }

  return (
    <div id="equipments" className={'panel-contenu'} style={{ height: height - 90 }}>
      <TopBar title={"équipements [" + ((equipments && equipments.length)?equipments.length:0) + "]"} className="topbar-contenu" color={props.params.color} buttons={
        <EquipmentsActions
          equipmentFamily={equipmentFamily}
          equipmentAutoroute={equipmentAutoroute}
          wsStatus={props.wsStatus} />
      }
      />

      <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>

        <ClipLoader
          color="#0094ca"
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
          size={50}
        />

        {!loading &&
          <AgGrid
            key={"ag-grid-ws-" + props.wsStatus}
            rowData={equipments}
            columnDefs={columnDefs}
            height={componentHeight}
            rowHeight={40}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={contratGridOptions}
            setGridOptions={setContratGridOptions}
            sortable={false}
            filters={storeFilter}
            handleOnDoubleClick={handleOnDoubleClick}
            agGridName="ag-grid-overflow"
          />
        }

      </div>
    </div>
  );

};

export default Equipments;
